import { Button, Modal, ModalProps } from 'antd';
import KanbanScheduleForm from '../KanbanScheduleForm';
import {
  useActivityDelete,
  useActivityDetail,
} from '@/core/domain/visual-management/activities/activities.hooks';
import './style.less';
import { Link } from 'react-router-dom';
import { Group } from '@/components/_common';
import { FaExternalLinkAlt } from 'react-icons/fa';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';

interface Props extends ModalProps {
  activityId?: string;
  onCancel: () => void;
}

const ScheduleEditModal: React.FC<Props> = ({ activityId, ...props }) => {
  const activityDetail = useActivityDetail(activityId);

  const deleteActivity = useActivityDelete();

  const handleRemoveActivity = async () => {
    Modal.confirm({
      title: 'Exclusão de Agendamento',
      content:
        'Deseja realmente excluir o agendamento, esse processo será irreversível.',
      onOk: async () => {
        try {
          await deleteActivity.mutateAsync(activityId);

          props.onCancel();
        } catch {}
      },
      okText: 'Excluir',
      okType: 'danger',
    });
  };

  return (
    <Modal
      {...props}
      title={
        <div className="schedule-edit-title">
          <strong>
            {activityDetail.data?.licensePlate
              ? `${activityDetail.data?.licensePlate} • ${activityDetail.data?.vehicle}`
              : activityDetail.data?.customer}
          </strong>
          {!!activityDetail.data?.licensePlate && (
            <span> {activityDetail.data?.customer}</span>
          )}
        </div>
      }
      width={600}
      okText="Salvar"
      destroyOnClose
      bodyStyle={{ position: 'relative', overflow: 'hidden' }}
      footer={null}
    >
      {activityDetail.isLoading && (
        <ModalLoadingOverlay
          messages={['Carregando dados...']}
          style={{ position: 'absolute', width: '100%', height: '100%' }}
        />
      )}

      {!!activityDetail.data?.complementIdentifier ? (
        <div style={{ marginBottom: 24 }}>
          <div style={{ lineHeight: 1 }}>Orçamento</div>
          <Link
            to={`/app/movements/workOrders/${activityDetail.data.workOrderId}/complements/${activityDetail.data.workOrderComplementId}/generalInfo`}
          >
            <Group gap={8}>
              <strong style={{ fontSize: '1.15rem' }}>
                {activityDetail.data?.complementIdentifier}
              </strong>

              <FaExternalLinkAlt />
            </Group>
          </Link>
        </div>
      ) : (
        <SpaceForButton
          style={{ marginBottom: 24, justifyContent: 'flex-end' }}
        >
          <Button
            block
            danger
            onClick={handleRemoveActivity}
            loading={deleteActivity.isLoading}
          >
            Remover agendamento
          </Button>
        </SpaceForButton>
      )}

      <KanbanScheduleForm
        onCancel={props.onCancel}
        activityDetail={activityDetail.data}
        activityDetailDataUpdatedAt={activityDetail.dataUpdatedAt}
        modalOpened={props.open}
      />
    </Modal>
  );
};

export default ScheduleEditModal;
